import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { SocketService } from 'src/app/socket.service';
import { environment } from '../../../environments/environment';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-display',
  templateUrl: './display.component.html',
  styleUrls: ['./display.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DisplayComponent implements OnInit, OnDestroy {
  // pre_diagnosis = ['Tuberculosis', 'Pneumothorax', 'Emphysema']
  account_id = localStorage.getItem('account_id')
  diagfiles: any[];
  diagItem: any;
  diagInfo: any;
  diagInfos: any = [];
  batchProcessing: {};
  isProcessing: boolean = true;
  list_upload_id: any = [];
  feedback: any
  data_queue: any
  id_data_queue: any
  string_queue: any
  comment_than: boolean = true
  pre_diagnosis_selete = JSON.parse(localStorage.getItem('pre_diagnosis_selete'))
  showpercent =  JSON.parse(localStorage.getItem('showpercent'));

  minute: any
  seconds: any
  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };
  feedbackAPI = `${environment.apiUrl}/history/feedback`

  constructor(
    private http: HttpClient,
    private route: Router,
    private socket: SocketService,
    public dialog: MatDialog,
    public _snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    if(this.showpercent == false){
      this.showpercent = 'no'
    }else{
      this.showpercent = 'yes'
    }
    // this.seconds = 0
    // this.minute = 0
    // console.log(this.account_id);
    this.socket.data_queue('data-queue').subscribe(data => {
      console.log('data-queue', data);
      this.id_data_queue = data['account_id']
      if (this.id_data_queue == this.account_id) {
        this.data_queue = data['queue']
        this.string_queue = `wait ${this.data_queue} queue ${this.data_queue} minute`
      }
    })

    this.batchProcessing = {};
    if (localStorage.getItem('diagfiles') != null && localStorage.getItem('diagfiles') != '[]') {
      this.diagfiles = JSON.parse(localStorage.getItem('diagfiles'));
      // console.log('diagfiles :',this.diagfiles);
      this.isProcessing = true;
      for (let i of this.diagfiles) {
        this.list_upload_id.push(i['upload_id'])
        // console.log('log',this.diagInfos);
      }
      this.http.post(`${environment.apiUrl}/log?account_id=${localStorage.getItem('account_id')}`, {
        log: this.list_upload_id,
        pre_diagnosis_selete: this.pre_diagnosis_selete,
        showpercent: this.showpercent
      }, this.httpOptions).subscribe(data => {
        // console.log(data);
        // if (data['message']['account_id'] == this.account_id) {
        //   this.startCountdown(data['message']['minute'])
        // }
      })
      // this.batchProcessing[this.diagfiles[0]['upload_id']] = true;
      this.diagfiles.forEach((f, index) => {
        // console.log(f);
        this.batchProcessing[f.upload_id] = true;

        this.socket.login_socket('data-post').subscribe(data => {
          console.log("data socket: ", data);
          if (data['result_ai'] == null) {
            this.route.navigate(['/main/upload']);
          }
          // this.data_socket = data['data']
          // this.batchProcessing[data['result_ai'][0]['upload_id']] = false;
          else if (f.upload_id == data['result_ai'][0]['upload_id']) {
            this.diagInfo = data['result_ai'][0];
            this.diagInfos.push(data['result_ai'][0]);
            // JSON.stringify(localStorage.setItem('diagInfos', this.diagInfos))
            console.log('diagInfos', this.diagInfos);
            this.batchProcessing[data['result_ai'][0]['upload_id']] = false;
            this.isProcessing = false;
          }
          // else if(f.upload_id != data['result_ai'][0]['upload_id']){
          //   this.data_queue = this.data_queue - 1
          //   this.string_queue = `wait ${this.data_queue} queue..........`
          //   if(this.data_queue == 0){
          //     this.string_queue = "wait processing......"
          //   }
          // }
          // console.log('diagInfos', this.diagInfos);
        })
      });
    }

    else {
      // TODO: redirect to upload page
      console.log('Error');
      this.route.navigate(['/main/upload']);
    }
  }

  // startCountdown(countdown){
  //   // var counter = seconds;
  //   this.minute = countdown - 1;
  //   this.seconds = 60 - 1;
  //   this.string_queue = `wait ${this.data_queue} queue ${this.minute}:${this.seconds} minute`
  //   var interval = setInterval(() => {
  //     console.log(this.seconds);
  //     this.seconds--;

  //     if(this.seconds < 0 ){

  //       // The code here will run when
  //       // the timer has reached zero.
  //       this.seconds = 60
  //       this.minute--
  //       // clearInterval(interval);
  //       console.log('minute', this.minute);
  //     };
  //     if(this.minute == 0 && this.seconds == 0){
  //       this.seconds = 0
  //       this.minute = 0
  //       clearInterval(interval);
  //     }
  //   }, 1000);
  // };

  displayXrayContent(item: any) {
    this.diagInfo = null;
    this.diagItem = item;
    this.batchProcessing[item.upload_id] = true;
    // TODO: check item in diagItems
    for (let i of this.diagInfos) {
      if (this.diagItem["upload_id"] == i['upload_id']) {
        this.diagInfo = i;
        this.batchProcessing[item.upload_id] = false;
        if (i['feedback'] == null) {
          this.comment_than = true
        } else {
          this.comment_than = false
        }
      }
    }
  }

  comment(data: any) {
    // this.feedback = ''
    // console.log(data);
    // console.log(this.diagInfos);
    for (let i = 0; i < this.diagInfos.length; i++) {
      if (data['upload_id'] == this.diagInfos[i]['upload_id']) {
        this.http.put(this.feedbackAPI, {
          feedback: this.feedback,
          upload_id: this.diagInfos[i]['upload_id']
        }, this.httpOptions).subscribe(res => {
          // console.log(res);
          this.diagInfos[i]['feedback'] = this.feedback;
          this.comment_than = false
          this.feedback = ''
          this._snackBar.open("Update feedback success.", 'Done', {
            duration: 3000,
          });
        }, err => {
          console.log(err);
          this._snackBar.open("Update feedback fail!.", 'Done', {
            duration: 3000,
          });
        })
      } else {
        this._snackBar.open("Please enter a feedback!.", 'Done', {
          duration: 3000,
        });
      }
    }
  }

  viewPic(item: any) {
    localStorage.setItem('pic', item)
    const dialogRef = this.dialog.open(dialog_view_picture, {
      width: '70%',
      height: '70%',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      localStorage.removeItem('pic')
    })
  }

  ngOnDestroy() {
    localStorage.removeItem('diagfiles');
  }

}

@Component({
  selector: 'dialog_view_picture',
  templateUrl: 'dialog-view-picture.html',
  styleUrls: ['display.component.scss']
})
export class dialog_view_picture implements OnInit {
  viewInfo = localStorage.getItem('pic');

  constructor(
    public dialogRef: MatDialogRef<dialog_view_picture>,
  ) {
  }

  ngOnInit() {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
